<template>
<div>
  <h1>
    <icon class="mr-2" size="0.9" type="film"/>
    {{ $t('createNewType', {type: $t(type)}) }}
  </h1>
  <organization-switcher
      class="mb-2"
      :org-selection-disabled="!!preSetOrganization"
      :pre-set-organization-id="preSetOrganization"
      @setTeam="id => {teamId = id}"
      @unsetTeam="teamId = ''"
  />
  <input
      :id="'name'"
      v-model="name"
      :class="['form-text mb-3 mt-3', $v.name.$dirty && $v.name.$error ? 'form-group--error' : '']"
      :placeholder="$t('enternamehere')"
      type="text"
      @input="delayTouch($v.name)"
  >

  <div v-if="$v.name.$dirty && !$v.name.required && $v.name.$error" class="form-error">{{
      $t('errors.required')
    }}
  </div>
  <div v-if="$v.name.$dirty && !$v.name.alphaNumSpace" class="form-error">{{ $t('errors.alphaNumSpaceOnly') }}</div>

  <div v-if="$v.name.$dirty && !$v.name.maxLength" class="form-error">{{
      $t('errors.atMostCharacters', {num: 500})
    }}
  </div>

  <div v-if="$v.name.$dirty && !$v.name.minLength" class="form-error">{{
      $t('errors.atLeastCharacters', {num: 3})
    }}
  </div>
  <div v-if="$v.name.$dirty && !$v.name.isUnique" class="form-error fadeIn">{{ $t('errors.mediaNameAlreadyExists') }}</div>
  <div v-if="error" class="form-error">{{ $t(error) }}</div>
  <div>
    <div class="vform-label white">
      <b>{{ $t('description') }}</b>
    </div>

    <textarea
        :id="'description'"
        v-model="description"
        :class="['form-text mb-3', $v.description.$dirty && $v.description.$error ? 'form-group--error' : '']"
        :placeholder="$t('enterdeschere')"
        @input="delayTouch($v.description)"
    />
    <div v-if="$v.description.$dirty && !$v.description.maxLength" class="form-error">
      {{ $t('errors.atMostCharacters', {num: 128}) }}
    </div>
  </div>
    <div
        class="settings-button d-inline-block icon-rotate-animation make-longer-animation switched-colors"
        :class="enableSaving ? '' : 'disabled-button'"
        @click="save"
    >
      <icon v-if="enableSaving" type="save"/>
      <icon v-else type="ban"/>
      {{ $t('SAVE') }}
    </div>
</div>
</template>

<script>
import OrganizationSwitcher from "@/components/organizations/OrganizationSwitcher.vue";
import Icon from "@/components/Icon.vue";
import VuelidateMixin from "@/components/mixins/VuelidateMixin.js.vue";
import {alphaNumSpace} from "@/customValidators";
import {required, minLength, maxLength} from 'vuelidate/lib/validators';
import {mediaCategories} from "@/enum";
export default {
  name: "AnchorPointCreator",
  components: {Icon, OrganizationSwitcher},
  mixins: [VuelidateMixin],
  props: {
    teams: {type: Array, default: () => []},
    preSetOrganization: {type: String, default: ''},
    type: {type: String, default: 'attachmentpoint'},
  },
  validations: {
    name: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(500),
      alphaNumSpace,
      async isUnique(value) {
        // standalone validator ideally should not assume a field is required
        if (value === '') {
          return true;
        }
        return await this.checkMediaUniqueWithDelay(value)
      },
    },
    description: {
      maxLength: maxLength(1024),
    }
  },
  data() {
    return {
      organizationId: '',
      teamId: '',
      name: '',
      description: '',
      error: null,
      enableSaving: false,
      validationTimeout: null,
    };
  },
  watch: {
    name() {
      this.error = null;
      this.checkSaving();
    },
    description() {
      this.checkSaving()
    },
    '$v.$invalid': function () {
      this.checkSaving();
    },
  },
  beforeMount() {
    if(this.preSetOrganization !== '') {
      this.organizationId = this.preSetOrganization;
    }
  },
  methods: {
    async checkMediaUniqueWithDelay(value) {
      if(this.validationTimeout) {
        clearTimeout(this.validationTimeout);
      }
      const $this = this;
      return new Promise((resolve) => {
        this.validationTimeout = setTimeout(async () => {
          await $this.$store.dispatch('checkIfMediaNameExists', {
            name: value,
            organizationId: $this.organizationId,
            type: this.type
          }).then(data => {
            console.log('uniqueness check resolved', data.length === 0);
            resolve(data.length === 0);
          });
        }, 500);
      });
    },
    checkSaving() {
      this.enableSaving = !this.$v.$invalid && this.name.trim() !== '';
    },
    delayTouch(field) {
      const $this = this;
      clearTimeout(field._timeout);
      field._timeout = setTimeout(() => {
        console.log('touching field');
        $this.touchField(field);
      }, 500);
    },
    touchField(field) {
      field.$touch();
    },
    async save() {
      this.error = "";
      return await this.$store.dispatch('clientCreateAsset', {
        name: this.name,
        description: this.description,
        organizationId: this.preSetOrganization !== '' ? this.preSetOrganization : this.organizationId,
        teams: [this.teamId],
        mediaCategory: mediaCategories.model,
        type: this.type
      }).then(item => {
        this.$emit('created', item);
      }).catch(e => {
        this.error = e;
      })
    },
  },
}
</script>


<style scoped lang="scss">
.fadeIn {
  animation: fadeInAnimation 2s ease-in;
  padding: 0 !important;
  margin-bottom: 0;
}
@keyframes fadeInAnimation {
  0% {
    padding: 0 !important;
    opacity: 0;
    height: 0;
  }
  50% {
    opacity: 0;
    height: 0;
  }
  100% {
    padding: 15px !important;
    opacity: 1;
    height: 40px;
  }
}
</style>